
import axios from '../axios-instance';

export const updateContentStatus = async (content, status, device) => {

        console.log('Updating content status...');

        const uri = `/device/${device.uuid}/content/${content.id}?status=${status}`;

        await axios.put(uri,
            {
            // payload
            },{
                headers: {
                    'Content-Type': 'application/json',
                    'x-device-uuid': `${device.uuid}`,
                },
            }
        ).then((res) => {
            if (res.status === 200) {
                if (res.data.message) {
                    console.log('STATUS: ', status + ' ', res.data.message);
                }
            }
        }
        ).catch((err) => {
            console.error('Error: ', err);
        });

}

/**
 * postEvent: 
 *      device
 *      event 
 *          category: string
 *          subcategory: string
 *          action: string
 *          label: string
 *          client_id : int | null
 *          campaign_id int | null
 *          content_id : int | null
 *          trigger_id : int | null
 **/   

export const postEvent = async(device, event) => {    
    await axios.post(`/event`, event, {
        headers: {
            'x-device-uuid': `${device.uuid}`,
        }
        }).then((res) => {
        if (res && res.data) {
            console.log('Event tracked', res.data);
            }
        }).catch((err) => {
            console.error('Error: ', err);
        }
    );
}

export const getCdnPath = (url) =>{
    
    if(!url) {
        return;
    } else if(!process.env.REACT_APP_CDN_ENABLED || process.env.REACT_APP_CDN_ENABLED !== 'true' || !process.env.REACT_APP_CDN_ORIGIN || !process.env.REACT_APP_CDN_HOST){
        return url;
    }

    return url.replace(
        process.env.REACT_APP_CDN_ORIGIN,
        process.env.REACT_APP_CDN_HOST
    );
}